import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // static targets = ["firstContainer", "temporaryBlocked", "saleNotification", "manualDistribution", "manualDistributionNotification", "draft", "forFree"];
  static targets = ["temporaryBlocked", "saleNotification", "manualDistribution", "manualDistributionNotification", "draft", "forFree"];
  static values = {
    firstSelected: Boolean,
    secondSelected: Boolean,
    firstStatus: String,
    secondStatus: String,
  };

  connect() {
    // if (this.firstSelectedValue) {
    //   this.firstContainerTarget.classList.remove("hidden");
    // }
    if (this.secondSelectedValue) {
      this.secondContainerTarget.classList.remove("hidden");
    }
  }

  toggle(e) {
    const value = e.target.value;
    switch (e.target.id) {
      case 'course_status_draft':
        this.manualDistributionNotificationTarget.classList.add("hidden");
        this.temporaryBlockedTarget.classList.add("hidden");
        this.saleNotificationTarget.classList.add("hidden");
        this.manualDistributionTarget.checked = false;
        break;
      case 'course_status_for_free':
        this.manualDistributionNotificationTarget.classList.add("hidden");
        this.saleNotificationTarget.classList.add("hidden");
        this.temporaryBlockedTarget.classList.add("hidden");
        this.manualDistributionTarget.checked = false;
        break;
      case 'course_manual_distribution':
        this.draftTarget.checked = false;
        this.forFreeTarget.checked = false;
        this.manualDistributionNotificationTarget.classList.toggle("hidden");
        break;
      case 'course_status_for_sale':
        this.temporaryBlockedTarget.classList.add("hidden");
        this.saleNotificationTarget.classList.remove("hidden");
        break;
      case 'course_status_temporary_block':
        this.temporaryBlockedTarget.classList.remove("hidden");
        break;
      default:

        break;
    }

  }
}
